import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseDefaultAndSpaceClassificationLevelsQueryRelayArtifact from '../hooks/__generated__/useDefaultAndSpaceClassificationLevelsQuery.graphql.ts';

export function preloadDefaultAndSpaceClassificationLevels(spaceKey: string = '') {
	return query({
		query: UseDefaultAndSpaceClassificationLevelsQueryRelayArtifact,
		variables: {
			spaceKey,
		},
	});
}
